import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  transition: border-color 0.15s;
  height: 100%;
  min-height: 32px;
  box-sizing: border-box;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primaryBase};
  }
`;

export const SearchIcon = styled.svg`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.primaryText};
  line-height: 1.4;

  &::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }
`;

export const ClearButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.foreground};
  color: ${({ theme }) => theme.colors.secondaryText};
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  transition: background 0.15s;

  &:hover {
    background: ${({ theme }) => theme.colors.heavyLineOutline};
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 6px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: 360px;
  overflow-y: auto;
  overscroll-behavior: contain;
  z-index: 1000;
  padding: 4px 0;
`;

export const ResultItem = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  margin: 0 4px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.08s ease;
  background: ${({ isActive, theme }) =>
    isActive ? theme.colors.highlights : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.colors.highlights};
  }
`;

export const ResultIcon = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.foreground};
  color: ${({ theme }) => theme.colors.primaryBase};
`;

export const ResultContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
`;

export const ResultSublabel = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
`;

export const EmptyState = styled.div`
  padding: 20px 12px;
  text-align: center;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const Spinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.secondaryText};

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  &::before {
    content: '';
    width: 14px;
    height: 14px;
    border: 2px solid ${({ theme }) => theme.colors.heavyLineOutline};
    border-top-color: ${({ theme }) => theme.colors.primaryBase};
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
    flex-shrink: 0;
  }
`;
